<script>
  import { Form, isDev, store, imgSrc } from '$client';
  const { city } = store;

  export let data;
  if (isDev() && !data)
    data = {
      header: 'Заявка на сотрудничество',
      description:
        'Если вы хотите предложить участие в социальных проектах или создать совместный проект, направляйте свои предложения нам, и мы найдем самое оптимальное решение для Вас.',
      button: 'Отправить ',
      fields: [
        {
          id: 1,
          __component: 'fields.tekst',
          placeholder: 'ФИО',
          pattern: '^[а-яА-Я ].{4,100}$',
          type: 'small',
          required: true,
          key: 'name',
        },
        {
          id: 2,
          __component: 'fields.telefon',
          required: true,
          description: null,
          key: 'phone',
        },

        {
          id: 2,
          __component: 'fields.pochta',
          placeholder: 'Электронная почта',
          description: null,
          required: false,
          key: 'email',
        },
        {
          id: 1,
          __component: 'fields.tekst',
          placeholder: 'Вопрос',
          description: null,
          pattern: null,
          type: 'big',
          required: true,
          key: 'name',
        },
      ],
    };
</script>

<section class="container main-form" id="form">
  <Form {data} />
  <div class="contact-block">
    <h3 class="h2">Контакты</h3>
    <address>
      {#each $city.block as address}
        <div>
          <img
            loading="lazy"
            src={imgSrc(address.img.data.attributes.url)}
            alt={address.img.data.attributes.alternativeText} />
          {#if address.href}
            <a href={address.href}>{address.header}</a>
          {:else}
            <p>{address.header}</p>
          {/if}
        </div>
      {/each}
    </address>
  </div>
</section>

<style lang="scss">
  section {
    position: relative;
    display: inline-flex;
    gap: 100px;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;

    @media only screen and (max-width: 991.98px) {
      flex-direction: column;
      gap: 40px;

      :global(form),
      > div {
        width: 100% !important;
      }

      > div > address {
        display: inline-flex !important;
        flex-flow: row wrap !important;
      }
    }

    @media only screen and (max-width: 767.98px) {
      gap: 80px;
      padding-block: 30px;
    }
  }

  .contact-block {
    width: calc(50% - 60px);
    font-size: 18px;
    font-family: Roboto;

    h3 {
      padding-bottom: 50px;
      color: #2c333c;
      font-weight: 800;
      font-family: Vela Sans;
    }

    address {
      display: flex;
      flex-direction: column;
      gap: 24px;
      align-items: flex-start;
      width: 100%;

      div {
        display: inline-flex;
        flex-wrap: nowrap;
        gap: 12px;
        align-items: center;
        justify-content: center;
        color: #2c333c;
      }

      a {
        color: #2c333c;
      }
    }
  }

  .main-form {
    :global(form) {
      width: calc(50%);
    }

    :global(form > p) {
      margin-bottom: 30px;
      color: rgb(44 51 60 / 85%);
      font-size: 18px;
      font-family: Roboto;
    }

    :global(form > div) {
      flex-direction: column;
      gap: 15px;
    }

    :global(> form > h2) {
      margin-bottom: 16px;
      font-weight: 800;
      font-family: Vela Sans;
    }

    :global(> form > button) {
      padding: 18px 40px;
      background: #22eaac;
      border-radius: 5px;
    }
  }
</style>
